<div class="row">
  <div class="col-12">
    <div class="card cds-card-shadow">
      <div class="card-body">
        <!-- SEARCH FORM-->
        <div class="row">
          <div class="col-12">
            <div class="card p-3 mb-3">
              <h6>{{ "Search" | translate }} :</h6>
              <hr class="mt-1" />
              <form [formGroup]="userForm" novalidate>
                <div class="row">
                  <div class="col-3">
                    <label class="form-label">{{ "Type" | translate }}</label>
                    <ng-select
                      [items]="operationType"
                      bindLabel="viewValue"
                      bindValue="value"
                      placeholder="{{ 'Type' | translate }}"
                      formControlName="type"
                    >
                    </ng-select>
                  </div>
                  <div class="col-4">
                    <label class="form-label">{{ "Users" | translate }}</label>
                    <ng-select
                      formControlName="name"
                      (change)="setUserId($event.userID)"
                      [clearable]="false"
                      [bindValue]="'value'"
                      [bindLabel]="'viewValue'"
                      [items]="users"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        <img
                          height="15"
                          width="15"
                          [src]="
                            item.role === 'SYSTEM_ADMIN'
                              ? 'assets/img/icon-coloured-role-system-admin.png'
                              : item.role === 'MANAGER'
                                ? 'assets/img/icon-coloured-role-manager.png'
                                : item.role === 'SECURITY_ADMIN'
                                  ? 'assets/img/icon-coloured-role-security-admin.png'
                                  : item.viewValue === 'All'
                                    ? 'assets/img/icon-coloured-users.svg'
                                    : 'assets/img/icon-coloured-role-user.png'
                          "
                       alt="role" />
                        {{ item.viewValue | translate }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <img
                          height="15"
                          width="15"
                          [src]="
                            item.role === 'SYSTEM_ADMIN'
                              ? 'assets/img/icon-coloured-role-system-admin.png'
                              : item.role === 'MANAGER'
                                ? 'assets/img/icon-coloured-role-manager.png'
                                : item.role === 'SECURITY_ADMIN'
                                  ? 'assets/img/icon-coloured-role-security-admin.png'
                                  : item.viewValue === 'All'
                                    ? 'assets/img/icon-coloured-users.svg'
                                    : 'assets/img/icon-coloured-role-user.png'
                          "
                       alt="role" />
                        {{ item.viewValue | translate }}
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-3">
                    <label class="form-label">{{
                      "Processes" | translate
                    }}</label>
                    <ng-select
                      placeholder="{{ 'Processes' | translate }}"
                      formControlName="processes"
                      [clearable]="false"
                      [items]="processDetails"
                      bindValue="name"
                      bindLabel="name"
                    >
                    </ng-select>
                  </div>
                  <div class="col-2 mt-4">
                    <button
                      [disabled]="showAppLoader || error"
                      class="btn btn-sm btn-primary m-1"
                      (click)="search()"
                      title="{{ 'Search' | translate }}"
                    >
                      <i class="fa fa-play-circle"></i>
                    </button>
                    <button
                      [disabled]="showAppLoader || !isEnabledClearBtn"
                      class="btn btn-sm btn-primary m-1"
                      (click)="clear()"
                      title="{{ 'Clear' | translate }}"
                    >
                      <i class="fa fa-minus-circle"></i>
                    </button>
                  </div>
                  <div class="col-5">
                    <label class="form-label">{{
                      "Date from" | translate
                    }}</label>
                    <div class="input-group">
                      <input
                        [readonly]="true"
                        class="form-control"
                        placeholder="yyyy-mm-dd"
                        name="dp"
                        formControlName="fromDate"
                        standalone="true"
                        ngbDatepicker
                        #d="ngbDatepicker"
                      />
                      <button
                        class="btn btn-outline-secondary bi bi-calendar3"
                        (click)="d.toggle()"
                        type="button"
                        aria-label="From Date Calendar"
                      >
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-5">
                    <label class="form-label">{{
                      "Date to" | translate
                    }}</label>
                    <div class="input-group">
                      <input
                        [readonly]="true"
                        class="form-control"
                        placeholder="yyyy-mm-dd"
                        name="dp2"
                        formControlName="toDate"
                        ngbDatepicker
                        #d2="ngbDatepicker"
                      />
                      <button
                        class="btn btn-outline-secondary bi bi-calendar3"
                        (click)="d2.toggle()"
                        type="button"
                        aria-label="To Date Calendar"
                      >
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>

                  <div class="col-2 mt-4">
                    <div
                      class="btn-group me-3 m-1 d-inline overflow-hidden rounded-pill"
                    >
                      <button
                        type="button"
                        (click)="exportAsXLSXLogTracer()"
                        [disabled]="logDesc.length === 0"
                        class="btn btn-primary btn-sm mt-2 rounded-end"
                      >
                        <i class="fa fa-print" title="Print User"></i>
                      </button>
                      <div
                        class="btn-group dropdown rounded-0"
                        ngbDropdown
                        role="group"
                        aria-label="Button group with nested dropdown"
                      >
                        <button
                          type="button"
                          class="btn btn-primary btn-sm mt-2 border-start dropdown-toggle dropdown-toggle-split mt-2 rounded-start"
                          ngbDropdownToggle
                          aria-label="Toggle Dropdown"
                        ></button>
                        <div class="dropdown-menu" ngbDropdownMenu>
                          <button
                            (click)="exportAsXLSXViolation()"
                            ngbDropdownItem
                          >
                            Violation Report
                          </button>
                          <button
                            (click)="exportAsXLSXAdministration()"
                            ngbDropdownItem
                          >
                            Administration Audit Trail Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <h6>{{ "Results" | translate }}</h6>
        <div class="row">
          <!-- FILTER -->
          <div class="col-12">
            <input
              class="form-control mb-1"
              placeholder="{{ 'Quick Filter' | translate }}"
              [disabled]="showAppLoader"
              [(ngModel)]="searchText"
            />
            @if (!isPageLoad) {
              <appspinner [startSpinner]="showAppLoader"></appspinner>
            }
          </div>
          <!--ERROR-->
          @if (error && errorMessage) {
            <div class="col-12">
              <div class="alert cds-alert alert-danger" role="alert">
                <div class="cds-alert-icon">
                  <i class="fa-solid fa-triangle-exclamation"></i>
                </div>
                <div class="cds-alert-content">{{ errorMessage }}</div>
              </div>
            </div>
          }
          <!--TABLE-->
          <div class="col-12">
            <table
              aria-describedby="table-logTracer"
              class="table table-striped"
              [mfData]="
                logDesc
                  | filter
                    : 'logDateDisplay,logUser,logProcess,logType,logOperation,logMessage'
                    : searchText
              "
              #mf="mfDataTable"
              [mfRowsOnPage]="15"
            >
              <thead>
                <tr>
                  <th>
                    <mfDefaultSorter by="logDateDisplay">{{
                      "Date" | translate
                    }}</mfDefaultSorter>
                  </th>
                  <th>
                    <mfDefaultSorter by="logUser">{{
                      "User" | translate
                    }}</mfDefaultSorter>
                  </th>
                  <th>
                    <mfDefaultSorter by="logProcess">{{
                      "Process" | translate
                    }}</mfDefaultSorter>
                  </th>
                  <th>
                    <mfDefaultSorter by="logType">{{
                      "Type" | translate
                    }}</mfDefaultSorter>
                  </th>
                  <th>
                    <mfDefaultSorter by="logOperation">{{
                      "Operation" | translate
                    }}</mfDefaultSorter>
                  </th>
                  <th>
                    <mfDefaultSorter by="logMessage">{{
                      "Message" | translate
                    }}</mfDefaultSorter>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (log of mf.data; track log) {
                  <tr>
                    <td>{{ log.logDateDisplay }}</td>
                    <td>{{ log.logUser }}</td>
                    <td>{{ log.logProcess }}</td>
                    <td>{{ log.logType | translate }}</td>
                    <td>{{ log.logOperation }}</td>
                    <td>{{ log.logMessage | translate }}</td>
                  </tr>
                }
              </tbody>
              @if (
                (
                  logDesc
                  | filter
                    : "logDateDisplay,logUser,logProcess,logType,logOperation,logMessage"
                    : searchText
                ).length > 15
              ) {
                <tfoot>
                  <tr>
                    <td colspan="10">
                      <mfBootstrapPaginator
                        [rowsOnPageSet]="[15, 50, 100]"
                      ></mfBootstrapPaginator>
                    </td>
                  </tr>
                </tfoot>
              }
            </table>
            @if (
              logDesc.length === 0 && !isPageLoad && !showAppLoader && !error
            ) {
              <div class="alert cds-alert alert-danger" role="alert">
                <div class="cds-alert-icon">
                  <i class="fa-solid fa-triangle-exclamation"></i>
                </div>
                <div class="cds-alert-content">
                  {{ "No records found." | translate }}
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
